export default __webpack_public_path__ + "navigation-examples-custom-destination-marker-thumbnail-v1-960-8d45b96bb8877e0ce9946d75f98145e8.png";